import { render } from "./MenuLink.vue?vue&type=template&id=234b9dee"
import script from "./MenuLink.vue?vue&type=script&lang=js"
export * from "./MenuLink.vue?vue&type=script&lang=js"
script.render = render

export default script